function isNumeric(value) {
	var ok = '0123456789,.';

	for(i=0; i < value.length ;i++) {
		if(ok.indexOf(value.charAt(i)) < 0) {
			return false;
		}
	}
	return true;
}

function isSelected(index) {
	if(index > 0)
		return true;
	return false;
}

function isChecked(field) {
	if(field.checked)
		return true;
	return false;
}

function lengthIsOk(input, length) {
	if(input.length >= length)
		return true;
	return false;
}

function empty(input) {
	if(input.length == 0)
		return true;
	return false;
}

function isKennitala(kennit) {
	kennit = kennit.replace(/(\d{6})-?(\d{4})/, '$1$2');
	// we should be okay by now, so let's start working on the input...
	var sum = kennit.charAt(0) * 3;
	sum = sum + kennit.charAt(1) * 2;
	sum = sum + kennit.charAt(2) * 7;
	sum = sum + kennit.charAt(3) * 6;
	sum = sum + kennit.charAt(4) * 5;
	sum = sum + kennit.charAt(5) * 4;
	sum = sum + kennit.charAt(6) * 3;
	sum = sum + kennit.charAt(7) * 2;

	// let's find out what vartala we got...
	var vartala = 11 - (sum % 11);
	if(vartala == 11)
		vartala = 0;

	// vartala should equal kennit.charAt(8)
	if(vartala == kennit.charAt(8)) {
		return true;
	}
	else {
		return false;
	}
}

function isEmail(e) {
	ok = "1234567890qwertyuiop[]asdfghjklzxcvbnm.@-_QWERTYUIOPASDFGHJKLZXCVBNM";
	for(i=0; i < e.length ;i++) {
		if(ok.indexOf(e.charAt(i))<0) {
			return (false);
		}
	}
	if (document.images) {
		re = /(@.*@)|(\.\.)|(^\.)|(^@)|(@$)|(\.$)|(@\.)/;
		re_two = /^.+\@(\[?)[a-zA-Z0-9\-\.]+\.([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
		if (!e.match(re) && e.match(re_two)) {
			return (-1);
		}
	}
}

function formError(el, msg) {
	alert(msg);
	el.focus();
	el.style.borderColor="red";
	return false;
}

function checkAll(checkAllBox)
{
	var checkbox = null;
	var checkboxes = document.getElementsByTagName('input');

	var regex = new RegExp('^'+ checkAllBox.value + '_', 'g');

	for(i = 0,length = checkboxes.length; i < length; i++) {
		checkbox = checkboxes[i];
		if(checkbox.type == 'checkbox') {
			if(checkbox.id.match(regex)) {
				checkbox.checked = checkAllBox.checked;
			}
		}
	}
}

function addOption(selectId, val, txt) {
	var objOption = new Option(txt, val);
	document.getElementById(selectId).options.add(objOption);
}

function showProgressbar()
{
	$('#progressDialog').dialog({
		title : 'Vinnsla í gangi ...',
		autoOpen : false,
		closeOnEscape: false,
		draggable : false,
		modal : true,
		resizable : false,
		width: 250,
		height: 150,
		dialogClass : 'progressDialog'
	}).dialog('open');
}

function hideProgressbar()
{
	$('#progressDialog').dialog('close');
}

$(document).ready(function() {
	// Find ALL <form> tags on your page
	$('#center form').not('.skipDisable').submit(function(){
		// On submit disable its submit button
    	$('input[type=submit]', this).not('.skipDisable').attr('disabled', 'disabled');
	});
    $('.ui-button').button();
});
